module.exports = {"share":{"rowsPerPage":"Rows","rangeSeparator":"of","noData":"No Data","welcomeText":"Welcome"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/share.json
// module id = 113
// module chunks = 35